module.exports = __webpack_public_path__ + "img/mansoura.f56fb8d2.jpg";